import { PickSessionSchema } from "@redotech/redo-model/wms/schema/pick-session";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const pickAndAssignItemToTote = {
  name: "pickAndAssignItemToTote" as const,
  input: z.object({
    pickSessionId: zExt.objectId(),
    itemId: zExt.objectId(),
    toteId: zExt.objectId(),
  }),
  output: z.object({
    success: z.boolean(),
    updatedPickSession: PickSessionSchema.nullish(),
    message: z.string().optional(),
  }),
};
